import {
  faAngleLeft,
  faArrowCircleLeft,
  faArrowRight,
  faBan,
  faBars,
  faChartPie,
  faCheck,
  faComment,
  faCopy,
  faDollarSign,
  faDownload,
  faEraser,
  faExternalLinkAlt,
  faHashtag,
  faHeart,
  faHome,
  faImage,
  faInfo,
  faLongArrowAltRight,
  faMapMarker,
  faNewspaper,
  faPen,
  faPercent,
  faPlus,
  faPlusSquare,
  faQrcode,
  faSave,
  faSearch,
  faShoppingBag,
  faShoppingCart,
  faSlidersH,
  faSmileBeam,
  faSort,
  faSortDown,
  faSortUp,
  faStamp,
  faStore,
  faTags,
  faTimes,
  faUpload,
  faUser,
  faUserCog,
  faUserLock,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

export const Icons = Object.freeze({
  ABRIR_MODAL: faLongArrowAltRight,
  ACEPTAR: faCheck,
  AGREGAR: faPlus,
  APP_ICON_2: faEraser,
  APP_ICON_3: faArrowRight,
  APP_ICON_4: faHeart,
  APP_ICON_5: faSearch,
  ATRAS: faAngleLeft,
  FILTRAR: faSlidersH,
  BANNER: faNewspaper,
  BENEFICIO: faShoppingCart,
  BUSCAR: faSearch,
  CARA_FELIZ: faSmileBeam,
  CATEGORIAS_NAVBAR: faTags,
  CATEGORIAS_ADMIN: faPlusSquare,
  CERRAR: faTimes,
  CERRAR_VENTANA: faWindowClose,
  CODIGO: faHashtag,
  COMENTARIO: faComment,
  COMERCIO: faShoppingBag,
  COMERCIO_ABRIR: faExternalLinkAlt,
  COMERCIO_SOLICITUD: faStore,
  COPIAR: faCopy,
  DESCARGAR: faDownload,
  DESCUENTO: faPercent,
  DROPDOWN: faSortDown,
  DROPUP: faSortUp,
  EDITAR: faPen,
  ELIMINAR: faEraser,
  ERROR: faTimes,
  ESTADISITCAS: faChartPie,
  EXITO: faCheck,
  GUARDAR: faSave,
  HISTORIAL_VENTAS: faPen,
  IMAGEN: faImage,
  IMPORTAR: faUpload,
  INFO: faInfo,
  INGRESAR: faUser,
  INICIO: faHome,
  MAPA: faMapMarker,
  MENU: faBars,
  ORDENAR: faSort,
  QR: faQrcode,
  PANEL_ADMIN: faUserCog,
  PERSONA: faUser,
  PRECIO: faDollarSign,
  RECHAZAR: faBan,
  VENTAS_WITH_PENDING_APPROVAL: faStamp,
  VOLVER: faArrowCircleLeft,
  WHATSAPP: faWhatsapp,
  USUARIO_COMERCIO: faUserLock
});

export const Paginacion = Object.freeze({
  /**Máximos números de páginas mostrados, ejemplo: 3 haría que si hay
 * 5 páginas y la actual es la 3, se muestren solo 2, 3, 4
 */
  MAX_PAGINAS_MOSTRADAS: 5,
  /**Cantidad de beneficios por página */
  BENEFICIOS_POR_PAGINA: 20,
  /**Cantidad de comentarios por página para un solo comercio */
  COMENTARIOS_COMERCIO_UNICO_POR_PAGINA: 5,
  /** Cantidad de comentarios por página  */
  COMENTARIOS_POR_PAGINA: 20,
  /** Cantidad de comercios por página */
  COMERCIOS_POR_PAGINA: 20,
  /** Cantidad de comercios por página cuando se muestran en tarjetas */
  COMERCIOS_TARJETAS_POR_PAGINA: 20,
});

// Se llaman carpetas pero en realidad son solo endpoints en el server
// El cliente no sabe como el server trata internamente las imágenes
export const Carpetas = Object.freeze({
  BANNERS: "images/banners/",
  LOGOS: "images/logos/",
  QR: "images/qr/"
});